import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Grid, Paper, Typography, Chip } from '@mui/material';

/**
 * Grid de ferramentas ARCA PDF (categorias + cards ícone/nome).
 * @param {{ categories: Array<{ id: string, label: string, tools: Array<{ id: string, name: string, description?: string, path: string, icon: React.ReactNode, enabled?: boolean }> }> }} props
 */
export default function ToolGrid({ categories }) {
  const navigate = useNavigate();

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 4 }}>
      {(categories || []).map((cat) => (
        <Box key={cat.id}>
          <Typography
            variant="overline"
            sx={{ color: '#64748b', fontWeight: 700, letterSpacing: 1.2, mb: 1.5, display: 'block' }}
          >
            {cat.label}
          </Typography>
          <Grid container spacing={2}>
            {(cat.tools || []).map((tool) => {
              const enabled = tool.enabled !== false;
              return (
                <Grid item xs={12} sm={6} md={4} lg={3} key={tool.id}>
                  <Paper
                    elevation={0}
                    role="button"
                    tabIndex={enabled ? 0 : -1}
                    onClick={() => enabled && navigate(tool.path)}
                    onKeyDown={(e) => {
                      if (!enabled) return;
                      if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        navigate(tool.path);
                      }
                    }}
                    sx={{
                      p: 2.5,
                      height: '100%',
                      borderRadius: 3,
                      border: '1px solid',
                      borderColor: enabled ? 'rgba(25,118,210,0.18)' : 'rgba(148,163,184,0.35)',
                      bgcolor: enabled ? '#fff' : 'rgba(248,250,252,0.9)',
                      cursor: enabled ? 'pointer' : 'not-allowed',
                      opacity: enabled ? 1 : 0.55,
                      transition: 'all 0.2s ease',
                      display: 'flex',
                      flexDirection: 'column',
                      gap: 1.25,
                      '&:hover': enabled
                        ? {
                            borderColor: '#1976d2',
                            boxShadow: '0 8px 24px rgba(25,118,210,0.15)',
                            transform: 'translateY(-2px)',
                          }
                        : undefined,
                    }}
                  >
                    <Box
                      sx={{
                        width: 48,
                        height: 48,
                        borderRadius: 2,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        bgcolor: enabled ? 'rgba(25,118,210,0.1)' : 'rgba(148,163,184,0.15)',
                        color: enabled ? '#1565c0' : '#94a3b8',
                      }}
                    >
                      {tool.icon}
                    </Box>
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
                      <Typography variant="subtitle1" fontWeight={700} color="text.primary">
                        {tool.name}
                      </Typography>
                      {!enabled && <Chip size="small" label="Em breve" variant="outlined" />}
                    </Box>
                    {tool.description && (
                      <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.45 }}>
                        {tool.description}
                      </Typography>
                    )}
                  </Paper>
                </Grid>
              );
            })}
          </Grid>
        </Box>
      ))}
    </Box>
  );
}
